import '.h{display:grid;}.ssr-plugin'
import '.b2{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ServiceProviderCard } from '@app/components/blocks/card/ServiceProviderCard'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import useMediaQuery from '@app/util/useMediaQuery'
import { Empty } from '@app/components/blocks/empty/Empty'
import PersonWithBinocularsImage from '@app/assets/images/person_with_binoculars.png'
import { useTranslations } from '@i18n/useLanguage'

export const HousingFormPageExperts = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.housingFormPage

  if (
    !housingForm?.serviceProviders ||
    housingForm.serviceProviders.length === 0
  ) {
    return (
      <Empty title={t.noExpertsTitle} imageSrc={PersonWithBinocularsImage} />
    )
  }

  return (
    <div className="h b2"
      style={{
        gridTemplateColumns: isMobile
          ? 'repeat(1, minmax(250px, 1fr))'
          : 'repeat(2, minmax(250px, 1fr))',}}
    >
      {(housingForm.serviceProviders ?? []).map((expert) => (
        <ServiceProviderCard
          key={expert.id}
          slug={expert.slug}
          name={expert.name}
          description={expert.description}
          banner={expert.banner}
          avatar={expert.avatar?.src}
          types={expert.type}
        />
      ))}
    </div>
  )
}
